import initialState from './initialState';
import * as actionTypes from '../constants/actionTypes';

const reward = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SELECTED:
      if (state.id !== action.id) {
        return state;
      }

      return Object.assign({}, state, {
        selected: !state.selected
      });

    case actionTypes.UNSELECT_ALL:
      return Object.assign({}, state, {
        selected: false
      });

    default:
      return state;
  }
};

const rewards = (state = initialState.rewards, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SELECTED:
      return state.map(r =>
        reward(r, action)
      );
    case actionTypes.UNSELECT_ALL:
      return state.map(r =>
        reward(r, action)
      );
    default:
      return state;
  }
};

export default rewards;



/** WEBPACK FOOTER **
 ** ./src/reducers/rewardsReducer.js
 **/